export default {
  'otp.oldPrice': '原价 ',
  'otp.details': '限时免费活动详情',
  'otp.effective': '有效时间',
  'otp.userTitle': '优惠用户',
  'otp.tip': '如果您已购买其他EngageLab产品，但未充值OTP，您仍可参与本次活动',
  'otp.service.dsc': '首次购买OTP产品的用户',
  'otp.event': '活动',
  'otp.tip1a': '在促销期间，首次充值OTP的用户将从充值之日起',
  'otp.tip1b': '30自然日内',
  'otp.tip1c': '免除OTP验证费。',
  'otp.notes1': '1. 本活动每个账户仅可参与一次。',
  'otp.notes2': `2. 一旦充值完成，将不再提供退款。如需进一步帮助，请`,
  'otp.notes2a': '联系我们',
  'otp.notes2b': '了解详情.',
  'otp.notes3': `3. EngageLab 保留对活动的最终法律解释权。`,
  'email.sem.title': '限时福利！新用户专享每日500封免费邮件 ',
  'email.sem.btn': '立即开始',
};
